import React, { useState, useEffect, useRef } from "react";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import SecondaryNav2 from "../../../../components/AdminComponents/SecondaryNav2";
import {
  CaAdminMenu,
  SecondaryNavCommunications,
} from "../../../../components/AdminComponents/MenuItems";

import ThirdBar from "../../../../components/AdminComponents/ThirdBar";
import {
  EditTwoTone,
  BackwardOutlined,
  FormOutlined,
  RetweetOutlined,
  InfoCircleTwoTone,
  HistoryOutlined,
} from "@ant-design/icons";
import {
  Row,
  Col,
  Input,
  Popover,
  Tag,
  Button,
  Spin,
  Select,
  Card,
  message,
  Tooltip,
} from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  capitalizeWords,
  getFullApplicationName,
  ModuleColor,
  UserTypeColor,
} from "../../../../components/icons/ApplicationColor";
import Axios from "../../../../api/Axios";
import { useNavigate, useParams } from "react-router-dom";
import { generateFinalText, quillModules } from "./helper";
import VariableAccess from "../../../../components/VariableAccess";
import { useDispatch, useSelector } from "react-redux";
import { setClientData } from "../../../../store/slices/OrgDetail";

const TemplateEdit = () => {
  const { id } = useParams();
  const history = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const [emailSingleTemplate, setEmailSingleTemplate] = useState({});
  const [text, setText] = useState("");
  const [fields, setFields] = useState([]);
  const [title, setTitle] = useState("");
  const [subject, setSubject] = useState("");
  const [userRoles, setUserRoles] = useState([]);
  const [invalidFields, setInvalidFields] = useState([]);
  const [allowedVariables, setAllowedVariables] = useState([]);
  const [loading, setLoading] = useState(false);
  const [removedButtons, setRemovedButtons] = useState("");
  const availableRoles = ["admin", "trainer", "attendee"];
  const dispatch = useDispatch();
  const namingData = useSelector((state) => state.orgdeatil);
  const LoadUser = async () => {
    setLoading(true);
    try {
      const res = await Axios.get(`/mailtemplate/${id}`);
      //console.log(res.data);
      setEmailSingleTemplate(res.data);
      dispatch(
        setClientData({
          templateName: res?.data?.title?.toUpperCase(),
        })
      );
      setLoading(false);
    } catch (err) {
      //console.log(err);
      setLoading(false);
      LoadFailed();
    }
  };
  const LoadUserwithoutLoader = async () => {
    try {
      const res = await Axios.get(`/mailtemplate/${id}`);
      //console.log(res.data);
      setEmailSingleTemplate(res.data);
      setLoading(false);
      history("/ca-admin/organization/communications/templates");
    } catch (err) {
      //console.log(err);
      setLoading(false);
      LoadFailed();
    }
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const editEmailTemplate = async (data) => {
    setLoading(true);
    try {
      await Axios.put(`/newmailtemplate/?id=${id}`, data, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      UpdateSuccessfull();
      LoadUserwithoutLoader();
    } catch (err) {
      //console.log(err);
      setLoading(false);
      UpdateFailed();
    }
  };
  useEffect(() => {
    LoadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const LoadFailed = () => {
    messageApi.open({
      type: "error",
      content: "Error loading the email template, Please try again later",
      duration: 5,
    });
  };
  const UpdateSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Email template updated successfully",
      duration: 5,
    });
  };

  const UpdateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Email template update failed",
      duration: 5,
    });
  };
  const RemoveButtons = () => {
    if (emailSingleTemplate?.body) {
      const buttonRegex = /<a.*?class="button1".*?>.*?<\/a>/g;
      const removedButtonsArray =
        emailSingleTemplate.body.match(buttonRegex) || [];
      const removedButtonsString = removedButtonsArray.join(" ");
      setRemovedButtons(removedButtonsString);
      const modifiedBody = emailSingleTemplate.body.replace(buttonRegex, "");
      setText(modifiedBody);
    }
  };

  useEffect(() => {
    setAllowedVariables(emailSingleTemplate?.variables);
    setSubject(emailSingleTemplate.subject || "");
    setTitle(emailSingleTemplate?.title || "");
    setUserRoles(emailSingleTemplate?.user_type);
    RemoveButtons();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailSingleTemplate]);
  const extractFields = (text) => {
    const regex = /{{([^}]+)}}/g;
    const matches = [...text?.matchAll(regex)];
    const extractedFields = matches?.map((match) => match[1]);

    const invalidFields = extractedFields?.filter(
      (field) => !allowedVariables.includes(field)
    );

    setInvalidFields(invalidFields);
    return extractedFields.filter((field) => allowedVariables?.includes(field));
  };

  useEffect(() => {
    const parsedFields = extractFields(text);
    setFields(parsedFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, allowedVariables]);

  const thirdMenuData = [
    {
      path: `/ca-admin/organization/communications/templates/edit-template/${id}`,
      name: namingData?.templateName,
      icon: (
        <EditTwoTone
          style={{ fontSize: "15.5px", marginRight: "5px", margintop: "1px" }}
        />
      ),
    },
    {
      path: `/ca-admin/organization/communications/templates/${id}/logs`,
      name: "TEMPLATE LOGS",
      icon: (
        <HistoryOutlined
          style={{ fontSize: "15.5px", marginRight: "5px", margintop: "1px" }}
        />
      ),
    },
  ];
  const handleRoleChange = (selectedRoles) => {
    setUserRoles(selectedRoles);
  };
  const userInfo = useSelector((state) => state.user);
  const handleSubmit = () => {
    const payload = {
      subject,
      title,
      application: emailSingleTemplate?.application,
      variables: allowedVariables,
      organization: userInfo?.data?.organization?.id,
      body: generateFinalText(text, removedButtons),
      user_type: userRoles,
      category: emailSingleTemplate?.category,
      second_category: emailSingleTemplate?.second_category,
    };
    console.log("Submitting Payload:", payload);
    editEmailTemplate(payload);
  };
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const quillRef = useRef(null);
  const handleButtonClick = (value) => {
    const editor = quillRef.current.getEditor();
    editor.focus();
    const selection = editor.getSelection();
    if (selection && typeof selection.index === "number") {
      const position = selection.index;
      console.log(quillRef, editor, selection, position);
      editor.insertText(position, ` {{${value}}} `);
      editor.setSelection(position + 5 + value.length);
    } else {
      console.log("No selection or cursor position found.");
    }
  };
  return (
    <CaSideNav props={CaAdminMenu}>
      {contextHolder}
      <SecondaryNav2 menuItems={SecondaryNavCommunications} />
      <Spin spinning={loading}>
        <ThirdBar menuItems={thirdMenuData} />
        <div style={{ margin: "20px" }}>
          <Row gutter={16}>
            <Col span={15}>
              <Card
                hoverable
                headStyle={{
                  backgroundColor: "#879cb3",
                  color: "white",
                  padding: "5.5px",
                }}
                bodyStyle={{ padding: 20 }}
                title={
                  <span
                    style={{
                      color: "white",
                      paddingLeft: "20px",
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: "15px",
                    }}
                  >
                    {capitalizeWords("TEMPLATE SUMMARY")}
                  </span>
                }
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <div
                    className="my-form-lables-withoutoverFlow"
                    style={{
                      fontSize: "14px",
                      paddingInline: "5px",
                      minWidth: "120px",
                    }}
                  >
                    {capitalizeWords("TEMPLATE TITLE")}
                  </div>
                  <Input
                    placeholder="Enter the template title"
                    className="my-form-input-antd-test-without-border"
                    style={{
                      marginLeft: "10px",
                    }}
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <div
                    className="my-form-lables-withoutoverFlow"
                    style={{
                      fontSize: "14px",
                      paddingInline: "5px",
                      minWidth: "120px",
                    }}
                  >
                    {capitalizeWords("EMAIL SUBJECT")}
                  </div>
                  <Input
                    placeholder="Enter the email subject"
                    className="my-form-input-antd-test-without-border"
                    style={{
                      marginLeft: "10px",
                    }}
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                  />
                </div>
                <ReactQuill
                  theme="snow"
                  value={text}
                  onChange={setText}
                  modules={quillModules}
                  ref={quillRef}
                  style={{
                    height: "350px",
                    marginBottom: "40px",
                    fontFamily: "Poppins",
                  }}
                />
                {invalidFields.length > 0 && (
                  <div
                    style={{
                      marginTop: "20px",
                      paddingTop: "10px",
                      color: "red",
                    }}
                  >
                    {invalidFields.map((invalidField, index) => (
                      <Popover
                        key={index}
                        content={`"${invalidField}" is not a valid variable.`}
                        title="Invalid Variable"
                        trigger="hover"
                      >
                        <Tag
                          color="red"
                          style={{ fontSize: "15px", marginLeft: "10px" }}
                        >
                          {`{{${invalidField}}}`}
                        </Tag>
                      </Popover>
                    ))}
                  </div>
                )}
              </Card>
            </Col>
            {/* test comment */}
            <Col span={9}>
              <Row>
                <Card
                  hoverable
                  headStyle={{
                    backgroundColor: "#879cb3",
                    color: "white",
                    padding: "5.5px",
                  }}
                  style={{
                    width: "100%",
                    minHeight: "150px",
                  }}
                  bodyStyle={{ padding: 20 }}
                  title={
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span
                        style={{
                          color: "white",
                          paddingLeft: "20px",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "15px",
                        }}
                      >
                        {capitalizeWords("AVAILABLE VARIABLES")}
                      </span>
                      <Tooltip title="Know More">
                        <InfoCircleTwoTone
                          className="hover-icon-login"
                          style={{
                            fontSize: "20px",
                            marginRight: "5px",
                          }}
                          onClick={showModal}
                        />
                      </Tooltip>
                    </span>
                  }
                >
                  {allowedVariables?.map((variable, index) => (
                    <Tooltip title="Click to add this variable in editor">
                      <Tag
                        key={index}
                        color={fields.includes(variable) ? "green" : "blue"}
                        style={{
                          fontSize: "14.5px",
                          marginBottom: "8px",
                          padding: "2.5px",
                          paddingInline: "10px",
                          fontFamily: "Poppins",
                        }}
                        onClick={() => handleButtonClick(variable)}
                      >
                        {variable}
                      </Tag>
                    </Tooltip>
                  ))}
                </Card>
              </Row>
              <Row style={{ marginTop: "20px" }}>
                <Card
                  hoverable
                  headStyle={{
                    backgroundColor: "#879cb3",
                    color: "white",
                    padding: "5.5px",
                  }}
                  style={{
                    width: "100%",
                  }}
                  bodyStyle={{ padding: 20 }}
                  title={
                    <span
                      style={{
                        color: "white",
                        paddingLeft: "20px",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "15px",
                      }}
                    >
                      {capitalizeWords("MODULE AND ROLE ACCESS")}
                    </span>
                  }
                >
                  <div
                    className="my-form-lables"
                    style={{
                      fontSize: "14px",
                      padding: "5px",
                      paddingRight: "15px",
                    }}
                  >
                    {capitalizeWords("MODULE")}
                    <Tag
                      color={ModuleColor(
                        getFullApplicationName(emailSingleTemplate?.application)
                      )}
                      title={getFullApplicationName(
                        emailSingleTemplate?.application
                      )}
                      style={{
                        fontWeight: "600",
                        marginLeft: "10px",
                        fontSize: "13.5px",
                      }}
                    >
                      {getFullApplicationName(emailSingleTemplate?.application)}
                    </Tag>
                  </div>
                  {(emailSingleTemplate?.application === "TL" ||
                    emailSingleTemplate?.application === "TC") && (
                    <>
                      <div
                        className="my-form-lables"
                        style={{
                          fontSize: "14px",
                          padding: "5px",
                          paddingRight: "15px",
                        }}
                      >
                        {capitalizeWords("Type")}
                        <Tag
                          color="magenta"
                          title={getFullApplicationName(
                            emailSingleTemplate?.type
                          )}
                          style={{
                            fontWeight: "600",
                            marginLeft: "10px",
                            fontSize: "13.5px",
                          }}
                        >
                          {emailSingleTemplate?.type}
                        </Tag>
                      </div>
                    </>
                  )}
                  {emailSingleTemplate?.application === "CB" && (
                    <>
                      <div
                        className="my-form-lables"
                        style={{
                          fontSize: "14px",
                          padding: "5px",
                          paddingRight: "15px",
                        }}
                      >
                        {capitalizeWords("category")}
                        <Tag
                          color="magenta"
                          title={getFullApplicationName(
                            emailSingleTemplate?.category_name
                          )}
                          style={{
                            fontWeight: "600",
                            marginLeft: "10px",
                            fontSize: "13.5px",
                          }}
                        >
                          {emailSingleTemplate?.category_name}
                        </Tag>
                      </div>
                      <div
                        className="my-form-lables"
                        style={{
                          fontSize: "14px",
                          padding: "5px",
                          paddingRight: "15px",
                        }}
                      >
                        {capitalizeWords("sub category")}
                        <Tag
                          color="geekblue"
                          title={getFullApplicationName(
                            emailSingleTemplate?.second_category_name
                          )}
                          style={{
                            fontWeight: "600",
                            marginLeft: "10px",
                            fontSize: "13.5px",
                          }}
                        >
                          {emailSingleTemplate?.second_category_name}
                        </Tag>
                      </div>
                    </>
                  )}
                  <div style={{ display: "flex", marginTop: "20px" }}>
                    <div
                      className="my-form-lables"
                      style={{
                        marginTop: "8px",
                        fontSize: "14px",
                        paddingInline: "5px",
                      }}
                    >
                      {capitalizeWords("ROLES")}
                    </div>
                    <div
                      style={{
                        minWidth: "50%",
                        marginLeft: "10px",
                      }}
                    >
                      <Select
                        mode="multiple"
                        placeholder="Select User Roles"
                        value={userRoles}
                        onChange={handleRoleChange}
                        style={{
                          width: "100%",
                          marginLeft: "10px",
                        }}
                      >
                        {availableRoles.map((role) => (
                          <Select.Option
                            key={role}
                            value={role}
                            style={{ paddingLeft: "20px" }}
                          >
                            <Tag
                              color={UserTypeColor(role)}
                              key={role}
                              title={role}
                              style={{
                                fontWeight: "600",
                                // fontSize: "13px",
                                fontSize: "13px",
                                // fontFamily: "Poppins",
                              }}
                            >
                              {role?.toUpperCase()}
                              {/* {capitalizeFirstLetter(role)} */}
                            </Tag>
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                </Card>
              </Row>
              <Row
                style={{
                  marginTop: "40px",
                  marginLeft: "5px",
                }}
              >
                <Button
                  htmlType="button"
                  disabled={false}
                  onClick={() => {
                    history("/ca-admin/organization/communications/templates");
                  }}
                >
                  <BackwardOutlined />
                  Back
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    background: "#f58029",
                    fontWeight: "600",
                    marginLeft: "20px",
                  }}
                  disabled={
                    invalidFields.length > 0 ||
                    emailSingleTemplate?.id === undefined
                  }
                  onClick={handleSubmit}
                  className="save-update-btn"
                >
                  Update
                  <FormOutlined />
                </Button>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={() => {
                    setAllowedVariables(emailSingleTemplate?.variables);
                    setSubject(emailSingleTemplate.subject || "");
                    setTitle(emailSingleTemplate.title || "");
                    RemoveButtons();
                  }}
                  style={{
                    marginLeft: "20px",
                  }}
                >
                  Reset
                  <RetweetOutlined />
                </Button>
              </Row>
            </Col>
          </Row>
        </div>
        <VariableAccess
          isVisible={isModalVisible}
          handleCancel={handleCancel}
        />
      </Spin>
    </CaSideNav>
  );
};

export default TemplateEdit;
